export const ADD_PUBLIC_OR_ETF_DIALOG_TITLE = 'Add Public Company / Exchange Traded Fund';
